import * as React from "react";
import { LossesForm } from "./LossesForm";

export function LossesSection() {
  return (
    <LossesForm />
  );
}
